<section>
    <form *ngIf="form" [formGroup]="form" (ngSubmit)="search()">
        <app-textbox
            formControlName="documentID"
            placeholder="Поиск по системному номеру"
            name="{{ getFieldTranslate('documentID') }}"
            i18-placeholder>
        </app-textbox>
        <app-textbox
            formControlName="edocumentNumber"
            placeholder="Поиск по номеру документа"
            name="{{ getFieldTranslate('documentNumber') }}"
            i18-placeholder>
        </app-textbox>
        <app-textbox
            formControlName="fileName"
            placeholder="Поиск по наименованию файла"
            name="{{ getFieldTranslate('fileName') }}"
            i18-placeholder>
        </app-textbox>
        <button i18n [disabled]="!checkForm()" type="button" appSkin="simple-gray no-shadow bold" (click)="clearForm()">Сбросить</button>
        <button i18n [disabled]="isLoading" type="submit" appSkin="simple-gray no-shadow bold">Поиск</button>
    </form>
    <app-search-document-list
        [data]="data"
        [notFound]="notfound"
        (appSelect)="select($event)">
    </app-search-document-list>
</section>
